import * as React from "react";
import { connect } from "react-redux";
import { ErrorBoundary } from "../../../errors/ErrorBoundary";
import { useCoughMarshalApiClient } from "../../../misc/api/CoughMarshalApiClient";
import Modal, { ModalSize } from "../../../misc/components/modal";
import * as Actions from "../actions";
import { AnalyseState } from "../interfaces/state";
import { OnIgnoreEnter } from '../AnalyseApp';
import Alert, { AlertCategoryEnum } from "../../../misc/components/Alert";
import { Authorization } from "../../../misc/components/Authorization";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../Core/SecurityContext";

interface AutoQCButtonStateProps {
    isQCStatementsModalOpen: boolean;
    
    dispatch: React.Dispatch<any>;
}
interface AutoQCButtonProps extends AutoQCButtonStateProps {
    sessionId: string;
}



const AutoQCButton = (props: AutoQCButtonProps) => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();
    const coughMarshalClient = useCoughMarshalApiClient();
    const [qcStatements, setQCStatements] = React.useState<{ microphone: string[], sensor: string[] } | undefined>();

    const closeModal = () => props.dispatch(Actions.ToggleQCStatementsAction.create(false));
    const openModel = () => props.dispatch(Actions.ToggleQCStatementsAction.create(true));

    React.useEffect(() => {
        const getQCStatements = async (sessionId: string) => {
            const recording = await coughMarshalClient.getRecording(sessionId);

            setQCStatements({ microphone: recording.microphoneQCRemarks?.split(";").filter(x => x.trim() !== "") ?? [], sensor: recording.sensorQCRemarks?.split(";").filter(x => x.trim() !== "") ?? [] });
        }

        getQCStatements(props.sessionId);
    }, []);

    if (qcStatements === undefined || (qcStatements.microphone.length === 0 && qcStatements.sensor.length === 0))
        return null;

    return (
        <Authorization permissionId={PermissionEnum.ViewAutoQCRemarks} studyId={study.id} currentPermissions={currentUserPermissions}>
            <span className="text-left">
                <button onClick={() => openModel()} className="btn btn-primary" onKeyDown={OnIgnoreEnter}>
                    QC Statements
                </button>
                <Modal
                    show={props.isQCStatementsModalOpen}
                    size={ModalSize.Normal}
                    header="Automatic QC Statements"
                    closeModalHandler={closeModal}
                >
                    <div className="modal-body">
                        <ErrorBoundary>
                            {qcStatements !== undefined && (qcStatements.microphone.length > 0 || qcStatements.sensor.length > 0) ?
                                <div>
                                    <p>
                                        <h3 className="text-info">Microphone</h3>
                                        {qcStatements.microphone.length > 0 ? <ul>
                                            {qcStatements.microphone.map(q => <li key={q}>{q}</li>)}
                                        </ul> : <Alert show={true} category={AlertCategoryEnum.Info}>No QC Statements for the microphone</Alert>}
                                    </p>
                                    <p>
                                        <h3 className="text-info">Sensor</h3>
                                        {qcStatements.sensor.length > 0 ? <ul>
                                            {qcStatements.sensor.map(q => <li key={q}>{q}</li>)}
                                        </ul> : <Alert show={true} category={AlertCategoryEnum.Info}>No QC Statements for the sensor</Alert>}
                                    </p>
                                </div>
                                : null
                            }
                        </ErrorBoundary>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={closeModal}>
                            Close
                        </button>
                    </div>
                </Modal>
            </span>
        </Authorization>
    );
}

const mapStateToProps = (state: AnalyseState) => {
    return {
        isQCStatementsModalOpen: state.core.isQCStatementsOpen,
    } as AutoQCButtonStateProps;
};

export default connect<AutoQCButtonStateProps, any>(mapStateToProps)(AutoQCButton);
